import { render, staticRenderFns } from "./CadastroSegmentos.vue?vue&type=template&id=fc86b6a0"
import script from "./CadastroSegmentos.vue?vue&type=script&lang=js"
export * from "./CadastroSegmentos.vue?vue&type=script&lang=js"
import style0 from "./CadastroSegmentos.vue?vue&type=style&index=0&id=fc86b6a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports